import type { CourseModule } from "@/core/types";
import { lektionTextInSpalten } from "./lektion-01-text-in-spalten";
import { lektionPowerQuery } from "./lektion-02-power-query";
import { lektionSpezialfilter } from "./lektion-03-spezialfilter";
import { lektionKonsolidieren } from "./lektion-04-konsolidieren";

/**
 * Die Registerkarte „Daten“ jenseits von Sortieren und Filtern.
 *
 * Text in Spalten wird am Ergebnis erkannt, Power Query über
 * `Workbook.queries` (ExcelApi 1.14), der Spezialfilter über die Namen, die
 * Excel dabei anlegt. Konsolidierungen kennt nur VBA.
 */
export const modulDatenAufbereiten: CourseModule = {
  id: "daten-aufbereiten",
  title: "Daten aufbereiten und abrufen",
  summary:
    "Text in Spalten, Power Query mit gespeicherten Aufbereitungsschritten, der " +
    "Spezialfilter mit ODER-Bedingungen und das Zusammenfassen mehrerer Blätter.",
  level: "Aufbau",
  lessons: [lektionTextInSpalten, lektionPowerQuery, lektionSpezialfilter, lektionKonsolidieren],
};
